import React, { useEffect, useState } from 'react';
import styles from './SubscriptionBundles.module.css';
import { useNavigate } from 'react-router-dom';
import { useSubscriptionLogic } from '../useSubscriptionLogic';
import BundleCard from 'components/SubscriptionComponents/BundleCard/BundleCard';
import { Breadcrumbs, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SubscriptionBundles = () => {
  const navigate = useNavigate();
  const [isAnnual, setIsAnnual] = useState(false);
  const { t } = useTranslation();
  const { fetchPublicTiersQuery, shopTier, assignTier, unassignTier, shopId, user, fetchCardRegister } =
    useSubscriptionLogic();

  useEffect(() => {
    if (user?.ownedShops[0]?.historyList?.length > 0) {
      setIsAnnual(
        user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.tier?.id === shopTier?.id
          ? user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.yearlyPricing
          : user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 2]?.yearlyPricing
      );
    }
  }, [user]);

  return (
    <div className={styles.mainContainer}>
      <Breadcrumbs aria-label='breadcrumb' className={styles.breadcrumb}>
        <button
          onClick={() => navigate(`/shops/${shopId}/administration/subscriptions`)}
          className={styles.breadcrumb_link}>
          {t('subscription.title')}
        </button>
        <Typography variant='body1'>{t('subscription.bundles.title')}</Typography>
      </Breadcrumbs>
      <div className={styles.switchContainer}>
        <Typography variant='body2'>{t('subscription.bundles.monthly')}</Typography>

        <Switch
          checked={isAnnual}
          onChange={() => setIsAnnual(!isAnnual)}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: 'var(--primary-background-secondary)'
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: 'var(--primary-background-secondary)'
            }
          }}
        />

        <Typography variant='body2'>{t('subscription.bundles.yearly')}</Typography>
      </div>
      {fetchPublicTiersQuery?.data && (
        <div className={styles.cardContainer}>
          {fetchPublicTiersQuery?.data?.data
            ?.sort((a, b) => a?.id - b?.id)
            ?.map((el, idx) => {
              return (
                <BundleCard
                  bundleData={el}
                  currentTier={shopTier}
                  assign={assignTier}
                  unassign={unassignTier}
                  isAnnual={isAnnual}
                  user={user}
                  cardRegisterData={fetchCardRegister?.data?.data}
                />
              );
            })}
        </div>
      )}
    </div>
  );
};

export default SubscriptionBundles;
